const isAndroidDevice = (): boolean => /Android/i.test(navigator.userAgent);

export default isAndroidDevice;
